/**
 * Minimal string interpolation helper.
 *
 * Replaces `{{name}}` placeholders in a template with the matching value
 * from `vars`. Used for the handful of dynamic UI strings that interpolate
 * runtime values.
 *
 * @example
 *   format('+{{count}} more', { count: 3 }) // => '+3 more'
 */
export function format(template: string, vars: Record<string, string | number | undefined> = {}): string {
  return template.replace(/\{\{\s*(\w+)\s*\}\}/g, (_match, key: string) =>
    key in vars ? String(vars[key] ?? '') : `{{${key}}}`,
  );
}
